import { array, boolean, date, number, object, string } from 'yup';
import { BuildAreaCounty, BuildAreaRegion, BuildAreaState } from './types';

export const buildAreaStateValidator = object<BuildAreaState>({
  id: string().required(),
  abbreviation: string().required(),
  heroImageId: string().nullable(),
  isActive: boolean(),
  name: string().nullable(),
  overview: string().nullable(),
  slug: string().required(),
  createdAt: date().required(),
  updatedAt: date().required(),
});

export const buildAreaRegionValidator = object<BuildAreaRegion>({
  id: string().required(),
  faq: array().of(object({
    id: string().required(),
    question: string().required(),
    answer: string().required(),
  })).required(),
  galleryId: string().nullable(),
  heroImageId: string().nullable(),
  isActive: boolean(),
  label: string().nullable(),
  name: string().nullable(),
  overview: string().nullable(),
  slug: string().required(),
  createdAt: date().required(),
  updatedAt: date().required(),
});

export const buildAreaCountyValidator = object<BuildAreaCounty>({
  branchId: string().nullable(),
  cities: array(string()),
  createdAt: date().required(),
  heroImageId: string().nullable(),
  id: string().required(),
  isActive: boolean().required(),
  label: string().nullable(),
  labelCoord: object({
    type: string().oneOf(['Point']).required(),
    coordinates: array(number()),
  }),
  name: string().required(),
  overview: string().nullable(),
  partialCoverage: boolean(),
  primaryCity: string().nullable(),
  region: buildAreaRegionValidator.notRequired().nullable(),
  regionId: string().nullable(),
  sfDevelopmentId: string().nullable(),
  slug: string().required(),
  state: buildAreaStateValidator.notRequired().nullable(),
  stateSlug: string().required(),
  updatedAt: date().required(),
});

